module.exports = __webpack_public_path__ + "static/img/pic_phone_2.1502258.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/pic_phone_2.png
// module id = DwXT
// module chunks = 1